import * as React from 'react';
import classNames from 'classnames';

import Button from '../button';
import Close from '../icons/24/close';
import Text from '../text';

import CheckboxList from './form-content.checkbox-list';
import RadioList from './form-content.radio-list';
import Range from './form-content.range';

import { FormContent as Props } from './form-content.types';

import { ContentKeys } from '../form-content/form-content.types';
import TabTrapper from '../modal/tab-trapper';

const Content = (content: Props['content']) => {
  switch (content.key) {
    case ContentKeys.Checkbox: {
      return <CheckboxList {...content} />;
    }
    case ContentKeys.Range: {
      return <Range {...content} />;
    }
    case ContentKeys.Radio: {
      return <RadioList {...content} />;
    }
  }
};

const FormContent: React.FC<Props> = ({
  content,
  closeLabel,
  isOpen = false,
  close,
  onSubmit,
  submitLabel,
  title,
}) => (
  <div className="form-content">
    {isOpen ? <div className="form-content__background-overlay"></div> : null}
    <TabTrapper isActive={isOpen}>
      <div
        className={classNames('form-content__modal', {
          'form-content__modal--open': isOpen,
        })}
        data-test-modal
      >
        <div className="form-content__modal-header">
          <Text
            elementName="span"
            theme={Text.themes.emphasis}
            size={Text.sizes.headline3}
            className="form-content__modal-title"
          >
            {title}
          </Text>
          <div className="form-content__modal-close-small">
            <Button
              variant={Button.variants.secondary}
              onClick={close}
              size={Button.sizes.small}
              leadingIcon={<Close />}
              ariaLabel={closeLabel}
            />
          </div>
        </div>
        <div className="form-content__modal-content">{Content(content)}</div>
        <div className="form-content__modal-action-wrapper">
          <div className="form-content__modal-actions">
            <div className="form-content__modal-close-large">
              <Button
                data-testid="close-form-content-modal"
                variant={Button.variants.secondary}
                size={Button.sizes.basic}
                text={closeLabel}
                onClick={close}
              />
            </div>
            <Button
              className="form-content__submit"
              variant={Button.variants.primary}
              size={Button.sizes.basic}
              type="submit"
              text={submitLabel}
              onClick={onSubmit}
            />
          </div>
        </div>
      </div>
    </TabTrapper>
  </div>
);

export default FormContent;
